<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div class="ts-app-shell--header">
        <h5>
          <strong>Manage Interest Criteria Mapping</strong>
        </h5>
        <div class="ts-app-shell--header_actions flexed"></div>
      </div>
      <span style="font-size: 14.4px;">
        On this page you can see all area of expertise you are interested in.
        You can view and update your existing mapping or remove them completely.
      </span>
    </div>
    <div class="ts-app-landing-dashboard">
      <div class="padd-main">
        <el-table
          :data="
            userinterestcriteria.filter(
              data =>
                !searchpathway ||
                data.pathwayNm
                  .toLowerCase()
                  .includes(searchpathway.toLowerCase())
            )
          "
          width="100%"
        >
          <el-table-column
            property="subjectAreaNm"
            label="Subject Area"
            width="200"
          >
          </el-table-column>
          <el-table-column property="level" label="Level" width="100">
          </el-table-column>
          <el-table-column property="pathwayNm" label="Pathway">
          </el-table-column>
          <el-table-column label="" width="200">
            <template slot="header">
              <div style="display:flex;flex-direction:row;">
                <el-tooltip placement="top" content="Refresh mapping list">
                  <span
                    @click="refreshList"
                    style="cursor:pointer;margin-top:3px;"
                    ><i
                      style="font-size:16px; margin-right: 10px;"
                      class="fas fa-sync-alt"
                    ></i
                  ></span>
                </el-tooltip>
                <el-input
                  v-model="searchpathway"
                  size="mini"
                  placeholder="Type to search"
                />
              </div>
            </template>
            <template slot-scope="scope">
              <el-button @click="viewCriteria(scope.row)">View/Edit</el-button>
              <el-button
                style="background-color:#14223C"
                class="ts-btn-small ts-btn-white"
                @click.prevent="deleteCriteria(scope.row)"
              >
                <i style="color:#fff" class="fas fa-trash-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.refreshList();
  },
  computed: {
    currentCriteria() {
      return this.$store.state.apprentice.current_apprentice_criteria;
    }
  },
  data() {
    return {
      userinterestcriteria: [],
      searchpathway: ""
    };
  },
  methods: {
    refreshList() {
      this.isLoading = true;
      this.$store.dispatch("apprentice/getuserinterestcriteria").then(res => {
        this.userinterestcriteria = res;
      });
    },
    viewCriteria(obj) {
      this.$store
        .dispatch("apprentice/getuserinterestcriteriadetail", obj.id)
        .then(res => {
          //this.currentCriteria = res.data;
          this.currentCriteria.id = res.id;
          this.currentCriteria.subjectArea = res.subjectArea;
          this.currentCriteria.level = res.level;
          this.currentCriteria.pathway = res.pathway;
          this.currentCriteria.sgaHiddenExtras = res.sgaHiddenExtras;
          this.currentCriteria.sgaKnowledge = res.sgaKnowledge;
          this.currentCriteria.sgaSkills = res.sgaSkills;
          this.currentCriteria.sgaMindset = res.sgaMindset;
          window.sessionStorage.setItem(
            "currentCriteria",
            JSON.stringify(this.currentCriteria)
          );
          this.$router.push({ path: "/interests/programcriteria" });
        });
    },
    deleteCriteria(obj) {
      this.$confirm(
        `Are you sure you want to delete your interest criteria?`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          showCancelButton: true,
          dangerouslyUseHTMLString: true,
          type: "warning",
          center: true
        }
      ).then(() => {
        this.$store
          .dispatch("apprentice/deleteuserinterestcriteria", obj.id)
          .then(res => {
            if (res) this.$message.success(`Interest criteria removed.`);
            else
              this.$message.error(
                `Cannot remove apprenticeship. Please contact your administrator.`
              );
            this.refreshList();
          });
      });
    }
  }
};
</script>
<style lang="scss"></style>
